// Shared `ordering` config helpers - config is
// {prompt, items:string[], correctPositions?:number[]}. correctPositions[i]
// is the correct 1-based slot for items[i] (a full permutation of 1..N).
// Absent/invalid -> array order IS the answer key (the original shape,
// before an explicit number could be assigned per item), so every existing
// ordering block keeps working unchanged.

export function isPermutation(positions, n) {
    if (!Array.isArray(positions) || positions.length !== n) return false;
    if (new Set(positions).size !== n) return false;
    return positions.every((p) => Number.isInteger(p) && p >= 1 && p <= n);
}

export function resolveCorrectPositions(items, positions) {
    const n = (items || []).length;
    return isPermutation(positions, n) ? positions : Array.from({ length: n }, (_, i) => i + 1);
}

// slot (0-based) -> index of the item that belongs there
export function correctItemBySlot(positions) {
    const bySlot = [];
    positions.forEach((p, itemIdx) => { bySlot[p - 1] = itemIdx; });
    return bySlot;
}

// Drops blank items while keeping the remaining ones' relative correct
// order, renumbered densely 1..K - blank rows must not leave gaps in the
// permutation.
export function compactItems(items, positions) {
    const resolved = resolveCorrectPositions(items, positions);
    const kept = items
        .map((text, i) => ({ text: (text || '').trim(), pos: resolved[i] }))
        .filter((o) => o.text);
    const ranked = [...kept].sort((a, b) => a.pos - b.pos);
    return {
        items: kept.map((o) => o.text),
        correctPositions: kept.map((o) => ranked.indexOf(o) + 1),
    };
}

export function shuffleNotSolved(indices, correctBySlot) {
    const copy = [...indices];
    const isSolved = () => copy.every((itemIdx, slot) => correctBySlot[slot] === itemIdx);
    for (let attempt = 0; attempt < 10; attempt++) {
        for (let i = copy.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [copy[i], copy[j]] = [copy[j], copy[i]];
        }
        if (copy.length < 2 || !isSolved()) break;
    }
    return copy;
}
